import { render, staticRenderFns } from "./bo-category.vue?vue&type=template&id=2c5cb800"
import script from "./bo-category.vue?vue&type=script&lang=js"
export * from "./bo-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports